import { render, staticRenderFns } from "./pagination-component.vue?vue&type=template&id=3e3346df&scoped=true&"
import script from "./pagination-component.vue?vue&type=script&lang=js&"
export * from "./pagination-component.vue?vue&type=script&lang=js&"
import style0 from "./pagination-component.vue?vue&type=style&index=0&id=3e3346df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3346df",
  null
  
)

export default component.exports